'use strict';

// const { EmailSendStatusView } = require("@hubspot/api-client/lib/codegen/marketing/transactional/api");

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// Media queries

const screenLG =  window.matchMedia("(min-width: 1280px)");
const screenMD =  window.matchMedia("(min-width: 1024px)");
const screenSM =  window.matchMedia("(min-width: 768px)");
const screenXS =  window.matchMedia("(min-width: 650px)");

// Body

const body = document.querySelector("body");

// Mobile navigation

const mobileNavToggle = document.querySelector('.mob-nav-toggle');
const mobileNav = document.querySelector('.mob-nav-outer');

mobileNavToggle.addEventListener('click', function() { 
  this.classList.toggle('is-active');
  mobileNav.classList.toggle('is-open');
  body.classList.toggle('is-fixed');
  body.classList.toggle('mob-nav-is-open');
});

const mobileSubNavItems = document.querySelectorAll('.mob-nav__list .menu-item-has-children');

mobileSubNavItems.forEach(function(mobileSubNavItem){
  const toggle = mobileSubNavItem.querySelector('a');
  const subNav = mobileSubNavItem.querySelector('.sub-menu');

  toggle.addEventListener('click', function() {
    this.classList.toggle('is-active');
    subNav.classList.toggle('is-open');
  });

});

// Main navigation

const navButtons = document.querySelectorAll('.menu-activate a');

navButtons.forEach(navButton => {
  const roleAttr = document.createAttribute('role');
  const tabIndexAttr = document.createAttribute('tabindex');
  roleAttr.value = 'button';
  tabIndexAttr.value = '0';
  navButton.setAttributeNode(roleAttr);
  navButton.setAttributeNode(tabIndexAttr);
});


const menus = document.querySelectorAll('.menu-activate');
const innerMenus = document.querySelectorAll('.sub-nav-content-outer');
const dropMenu = document.getElementById('drop-menus');
const subNavWrapper = document.querySelector('.sub-nav-outer');
const subNavCurrentHeight = subNavWrapper.offsetHeight;

document.addEventListener("DOMContentLoaded", function(e) {
  e.preventDefault();

  let currentNav = '';
  let highestNav = 0;

  menus.forEach(function(menu) {    
    menu.addEventListener('click', function() {

      menus.forEach(function(all_menu) {
        all_menu.classList.remove('active-menu');
      });

      menu.classList.add('active-menu');
      // Add a class to the body

      setTimeout(function(){
        body.classList.add('nav-is-open');
      }, 500);

      // hide current menus

      innerMenus.forEach(function(innerMenu) {
        const innerMenuHeight = innerMenu.offsetHeight;
        highestNav = innerMenuHeight > highestNav ? innerMenuHeight : highestNav;
        innerMenu.classList.remove('is-visible');
      });

      subNavWrapper.style.height = (subNavCurrentHeight + highestNav) + 'px';

      const menuClasses = menu.className.split(' ');

      // if we click same name item, do nothing

      if(currentNav == menuClasses[0]) {
        currentNav = '';
        subNavWrapper.classList.remove('is-open');
        setTimeout(function(){
          body.classList.remove('nav-is-open');
        }, 500);
        return;
      } else {
        currentNav = menuClasses[0];
      }

      dropMenu.classList.add('is-open');
      document.getElementById(menuClasses[0]).classList.add('is-visible');
    });
  });

});

// Remove menu states at certain breakpoints

function removeMenuClasses(e) {
  if(e.matches) {
    body.classList.remove('is-fixed');
    body.classList.remove('mob-nav-is-open');
    mobileNavToggle.classList.remove('is-active');
    mobileNav.classList.remove('is-open');

    mobileSubNavItems.forEach(function(mobileSubNavItem){
      mobileSubNavItem.querySelector('a').classList.remove('is-active');
      mobileSubNavItem.querySelector('.sub-menu').remove('is-open');
    });

  } else {
    body.classList.remove('nav-is-open');
    dropMenu.classList.remove('is-open');
    subNavWrapper.style.height = '';

    innerMenus.forEach(function(menu) {
      menu.classList.remove('is-visible');
    });
    
  }
}

if (screenMD.addEventListener) {
  screenMD.addEventListener("change", removeMenuClasses);
} else {
  screenMD.addListener(removeMenuClasses);
}

removeMenuClasses(screenMD);

// Close nav

const subNavs = document.querySelectorAll('.sub-nav-outer');
const closeSubNavBtns = document.querySelectorAll('.close-sub-nav');
const activeMenus = document.querySelectorAll('.main-nav__list li');

closeSubNavBtns.forEach(function(closeSubNavBtn){
  closeSubNavBtn.addEventListener('click', function(){

    subNavs.forEach(function(subNav){
      if(subNav.classList.contains('is-open')){
        subNav.classList.remove('is-open');
      }
    });

    activeMenus.forEach(function(activeMenu){
      activeMenu.classList.remove('active-menu');
    });
  });
})

// subNavs.forEach(function(subNav){
//   const closeSubNavBtn = subNav.querySelector('.close-sub-nav');

//   console.log(closeSubNavBtn);

//   closeSubNavBtn.addEventListener('click', function(){
//     console.log('yes');
//   });

// });

// Service promo

const tabTrigger = document.querySelector('.services-promo__list__link');
const tabTriggerBtns = document.querySelectorAll('.services-promo__list__link');
const tabs = document.querySelector('.services-promo__list');
const visibleImg = document.querySelector('.services-promo__img.is-visible');
// const tabContent = document.querySelector(".tab-content");

tabTriggerBtns.forEach(function (tabTriggerBtn) {
  tabTriggerBtn.addEventListener('mouseenter', function () {
    const currentTabData = document.querySelector(
      '.services-promo__img.is-hidden[data-service-img="' + this.dataset.serviceLink + '"]'
    );
    const openContent = document.querySelector(".services-promo__img.is-visible");

    if (openContent) {
      openContent.classList.remove("is-visible");
      openContent.classList.add('is-hidden');
    }

    currentTabData.classList.add("is-visible");
    currentTabData.classList.remove('is-hidden');
  });

  tabTriggerBtn.addEventListener('mouseleave', function () {
    const openContent = document.querySelector(".services-promo__img.is-visible");

    if (openContent) {
      openContent.classList.remove("is-visible");
      openContent.classList.add('is-hidden');
    }
  });

});

// Investor nav toggle

const investorNavToggle = document.querySelector('.investor-nav__toggle');
const investorNavList = document.querySelector('.investor-nav__list');

if(investorNavToggle) {
  investorNavToggle.addEventListener('click', function(){
    this.classList.toggle('is-active');
    investorNavList.classList.toggle('is-open');
  });
}

// Video grid

// const videoGridItems = document.querySelectorAll('.video-grid__toggle');
// const videoGridModals = document.querySelectorAll('.video-grid__modal');

// let triggerVal;
// let linkedVal;

// videoGridItems.forEach(function(videoGridItem){
//   videoGridItem.addEventListener('click', function (e) {
//     triggerVal = e.target.dataset.videoToggle;

//     if (e.currentTarget !== e.target) {
//       return;
//     }
//     // for (const videoGridModal of videoGridModals) {
//     //   linkedVal = videoGridModal.dataset.videoModal;
//     //   if (linkedVal === triggerVal) {
//     //     videoGridModal.classList.add('is-open');
//     //   }  
//     // }
//   });
// });

// const openedVideoGridModal = document.querySelector('.video-grid__modal');
// const closeVideoModal = openedVideoGridModal.querySelector('.video-grid__modal__close');

// if(closeVideoModal) {
// 	closeVideoModal.addEventListener('click', function(){
//     videoGridModals.forEach(function(videoGridModal) {
//       videoGridModal.classList.remove('is-open');
//     });
// 		//modalVideo.src = ''; // Clear the src of the iframe
// 		//openedVideoGridModal.classList.remove('is-open');// Close the modal
// 	});
// }

// // videoGridModals.forEach(function(videoGridModal) {
// //   if(videoGridModal.classList.includes('is-open')) {
// //     const closeBtn = videoGridModal.querySelector('.video-grid__modal__close');
// //     closeBtn.addEventListener('click', function(){
// //       this.classList.remove('is-open');
// //     });
// //   }
// // });

// Mini news feed

const newsFeedSliders = document.querySelectorAll('.news-feed-slider');

if(newsFeedSliders.length > 0) {

  newsFeedSliders.forEach(function(newsFeedSlider){
    const slider = newsFeedSlider.querySelector('.block-slider__slides');
    const previousBtn = newsFeedSlider.querySelector('.slider-control--previous');
    const nextBtn = newsFeedSlider.querySelector('.slider-control--next');

    const sliderConfig = new Flickity( slider, {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      selectedAttraction: 0.2,
      friction: 0.8,
      cellAlign: 'left',
      draggable: false
    });

    previousBtn.addEventListener( 'click', function() {
      sliderConfig.previous();
    });

    nextBtn.addEventListener( 'click', function() {
      sliderConfig.next();
    });

    const slides = newsFeedSlider.querySelectorAll('.block-slider__slide');

    // ANTO CAN WE IMPROVE??

    function showHideControls(e) {
      if(e.matches && slides.length < 4) {
        previousBtn.setAttribute('disabled', 'true');
        previousBtn.style.display = 'none';
        nextBtn.setAttribute('disabled', 'true');
        nextBtn.style.display = 'none';
        newsFeedSlider.classList.add('disabled');
      } else {
        previousBtn.removeAttribute('disabled');
        previousBtn.style.display = 'block';
        nextBtn.removeAttribute('disabled');
        nextBtn.style.display = 'block';
        newsFeedSlider.classList.remove('disabled');
      }
    }

    if (screenMD.addEventListener) {
      screenMD.addEventListener("change", showHideControls);
    } else {
      screenMD.addListener(showHideControls);
    }
    
    showHideControls(screenMD);

  });

}

// Stats carousel

const statsCarousels = document.querySelectorAll('.stats-carousel');

if(statsCarousels.length > 0) {

  statsCarousels.forEach(function(statsCarousel){
    const carousel = statsCarousel.querySelector('.block-slider__slides');
    const previousBtn = statsCarousel.querySelector('.slider-control--previous');
    const nextBtn = statsCarousel.querySelector('.slider-control--next');

    const carouselConfig = new Flickity( carousel, {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      selectedAttraction: 0.2,
      friction: 0.8,
      cellAlign: 'left',
      draggable: false
    });

    previousBtn.addEventListener( 'click', function() {
      carouselConfig.previous();
    });

    nextBtn.addEventListener( 'click', function() {
      carouselConfig.next();
    });

    // Disable buttons if only one slide

    const slides = statsCarousel.querySelectorAll('.block-slider__slide');

    // Refresh page to resize slides

    function refreshSizes() {
      if (screenLG.addEventListener) {
        screenLG.addEventListener("change", function(){
          window.location.reload();
        });
      } else if (screenMD.addEventListener) {
        screenMD.addEventListener("change", function(){
          window.location.reload();
        });
      } else if (screenSM.addEventListener) {
        screenSM.addEventListener("change", function(){
          window.location.reload();
        });
      }
    }

    refreshSizes();

    // ANTO CAN WE IMPROVE??

    function showHideControls(e) {
      if(e.matches && slides.length < 4) {
        previousBtn.setAttribute('disabled', 'true');
        previousBtn.style.display = 'none';
        nextBtn.setAttribute('disabled', 'true');
        nextBtn.style.display = 'none';
        statsCarousel.classList.add('disabled');
      } else {
        previousBtn.removeAttribute('disabled');
        previousBtn.style.display = 'block';
        nextBtn.removeAttribute('disabled');
        nextBtn.style.display = 'block';
        statsCarousel.classList.remove('disabled');
      }
    }

    if (screenMD.addEventListener) {
      screenMD.addEventListener("change", showHideControls);
    } else {
      screenMD.addListener(showHideControls);
    }
    
    showHideControls(screenMD);

  });

}

// Need to add this because adding 100% height in CSS breaks the slider - not ideal!!

const statsCarouselItems = document.querySelectorAll('.stats-carousel .block-slider__slide');

if(statsCarouselItems.length > 0) {
  
  statsCarouselItems.forEach(function(statsCarouselItem) {
    statsCarouselItem.style.height = '100%';
  });

}

// Media carousel

const mediaCarousels = document.querySelectorAll('.media-carousel-outer');

if(mediaCarousels.length > 0) {

  mediaCarousels.forEach(function(mediaCarousel) {
    const carousel = mediaCarousel.querySelector('.media-carousel__slides');
    const previousBtn = mediaCarousel.querySelector('.slider-control--previous');
    const nextBtn = mediaCarousel.querySelector('.slider-control--next');

    const carouselConfig = new Flickity( carousel, {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      selectedAttraction: 0.2,
      friction: 0.8,
      cellAlign: 'center',
      initialIndex: 2,
      draggable: false
    });

    previousBtn.addEventListener( 'click', function() {
      carouselConfig.previous();
    });

    nextBtn.addEventListener( 'click', function() {
      carouselConfig.next();
    });

    // Disable buttons if only one slide

    const slides = mediaCarousel.querySelectorAll('.media-carousel__slide');

    if(slides.length < 2) {
      previousBtn.setAttribute('disabled', 'true');
      previousBtn.style.display = 'none';
      nextBtn.setAttribute('disabled', 'true');
      nextBtn.style.display = 'none';
    }

  });

}

// Accordion

let accordion = '';
const accordionItems = document.querySelectorAll('.accordion__item');
const toggles = document.querySelectorAll('.accordion__item__toggle');

accordionItems.forEach(function (accordionItem) {
  const currentAccordionToggle = accordionItem.querySelector('.accordion__item__toggle');
  const currentAccordionContent = accordionItem.querySelector('.accordion__item__content');
  
    currentAccordionToggle.addEventListener('click', function(){
      
      // remove is-active from all here
      toggles.forEach(function (toggle) {
        toggle.classList.remove('is-active');
      });
      
      const accordionContents = document.querySelectorAll('.accordion__item__content');
      
      accordionContents.forEach(function(accordionContent) {
        accordionContent.classList.remove('is-open');
      });
      
      if(accordion != currentAccordionContent.id) {
        currentAccordionContent.classList.add('is-open');
        // then add is-active to the clicked one
        currentAccordionToggle.classList.add('is-active');
        accordion = currentAccordionContent.id;

        // window.scrollTo(0, currentAccordionToggle.offsetTop);
        currentAccordionToggle.scrollIntoView();
      } else {
        accordion = '';
      }

    });
    
});

document.addEventListener('click', function(e) {
  if(!e.target.classList.contains('accordion__item__toggle')) {
    accordionItems.forEach(function (accordionItem, index) {
      const currentAccordionContent = accordionItem.querySelector('.accordion__item__content');
      currentAccordionContent.classList.remove('is-open');
    });
    
    toggles.forEach(function (toggle) {
      toggle.classList.remove('is-active');
      accordion = '';
    });
  }
});

// Animated hero

function animatedHero (outer, inner_one, inner_two) {
  if(outer) {

    // Mouse
    const mouse = {
      _x: 0,
      _y: 0,
      x: 0,
      y: 0,
      updatePosition: function (event) {
        const e = event || window.event;
        this.x = e.clientX - this._x;
        this.y = (e.clientY - this._y) * -1;
      },
      setOrigin: function (e) {
        this._x = e.offsetLeft + Math.floor(e.offsetWidth / 2);
        this._y = e.offsetTop + Math.floor(e.offsetHeight / 2);
      },
      show: function () {
        return "(" + this.x + ", " + this.y + ")";
      }
    };

    // Track the mouse position relative to the center of the outer.
    mouse.setOrigin(outer);

    //-----------------------------------------

    let counter = 0;
    const updateRate = 10;
    const isTimeToUpdate = function () {
      return counter++ % updateRate === 0;
    };


    //-----------------------------------------

    const onMouseEnterHandler = function (event) {
      update(event);
    };


    const onMouseLeaveHandler = function () {
      inner_one.style = "";
      inner_two.style = "";
    };

    const onMouseMoveHandler = function (event) {
      if (isTimeToUpdate()) {
        update(event);
      }
    };

    //-----------------------------------------

    const update = function (event) {
      mouse.updatePosition(event);
      updateTransformStyleOne(
        (mouse.y / inner_one.offsetHeight / 2).toFixed(2),
        (mouse.x / inner_one.offsetWidth / 2).toFixed(2)
      );

      updateTransformStyleTwo(
        (mouse.y / inner_two.offsetHeight / 2).toFixed(2),
        (mouse.x / inner_two.offsetWidth / 2).toFixed(2)
      );
    };

    const updateTransformStyleOne = function (x, y) {
      const style = "rotateX(" + x + "deg) rotateY(" + y + "deg)";
      inner_one.style.transform = style;
      inner_one.style.webkitTransform = style;
      inner_one.style.mozTransform = style;
      inner_one.style.msTransform = style;
      inner_one.style.oTransform = style;
    };

    const updateTransformStyleTwo = function (x, y) {
      const style = "rotateX(" + x + "deg) rotateY(" + y + "deg)";
      inner_two.style.transform = style;
      inner_two.style.webkitTransform = style;
      inner_two.style.mozTransform = style;
      inner_two.style.msTransform = style;
      inner_two.style.oTransform = style;
    };

    //-----------------------------------------

    outer.onmouseenter = onMouseEnterHandler;
    outer.onmouseleave = onMouseLeaveHandler;
    outer.onmousemove = onMouseMoveHandler;

  }
}

const homeHeroOuter = document.querySelector('.home-hero');
const homeHeroInner1 = document.querySelector('.home-hero__inner-1');
const homeHeroInner2 = document.querySelector('.home-hero__inner-2');

// animatedHero(homeHeroOuter, homeHeroInner1, homeHeroInner2);

// Turning perspective off for Safari - not ideal but the last resort

if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
  body.classList.add('is-safari');
} else {
  animatedHero(homeHeroOuter, homeHeroInner1, homeHeroInner2);
}


// Services list

const serviceListRoot = document.querySelector(".services-list-outer");
const mediaQuery = window.matchMedia("(min-width: 768px)");


if(serviceListRoot) {

  const scrollIntoView = () => {
    const posts = serviceListRoot.querySelectorAll(".services-list__item");

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          const visiblePost = entry.target;
          if (entry.isIntersecting) {
            visiblePost.classList.add("is-highlighted");
          } else {
            visiblePost.classList.remove("is-highlighted");
          }
        });
        const activePost = serviceListRoot.querySelector(".is-highlighted");
        const currentImg = document.querySelector('.services-img[data-service-img="' + activePost.dataset.serviceLink + '"]');

        // remove classess
        document.querySelector(".services-img.is-showing").classList.remove("is-showing");

        // add classes
        currentImg.classList.add("is-showing");
      },
      {
        root: serviceListRoot,
        rootMargin: "-50%"
      }
    );

    posts.forEach((post) => {
      observer.observe(post);
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    if(mediaQuery.matches) {
      scrollIntoView();
    }
  });
}

// Animated text reveals

document.addEventListener("DOMContentLoaded", function() {
  const fadeUpAnimations = document.querySelectorAll('.js-fade-up');
  const fadeDownAnimations = document.querySelectorAll('.js-fade-down');
  const fadeLeftAnimations = document.querySelectorAll('.js-fade-left');
  const fadeRightAnimations = document.querySelectorAll('.js-fade-right');
  const fadeInAnimations = document.querySelectorAll('.js-fade-in');
  const fadeInSlowAnimations = document.querySelectorAll('.js-fade-in-slow');

  const config = {
    root: null,
    rootMargin: "0px",
    threshold: 0
  };

  function fadeAnimation(animations) {
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((element) => {
        if (element.isIntersecting) {
          element.target.classList.add('has-animated');
        }
      });
    }, config);
    
    animations.forEach((item) => {
      observer.observe(item);
    });
  }

  fadeAnimation(fadeUpAnimations);
  fadeAnimation(fadeDownAnimations);
  fadeAnimation(fadeLeftAnimations);
  fadeAnimation(fadeRightAnimations);
  fadeAnimation(fadeInAnimations);
  fadeAnimation(fadeInSlowAnimations);
});

// Detect flexbox gap property

function checkFlexGap() {
  // create flex container with row-gap set
  var flex = document.createElement("div");
  flex.style.display = "flex";
  flex.style.flexDirection = "column";
  flex.style.rowGap = "1px";

  // create two, elements inside it
  flex.appendChild(document.createElement("div"));
  flex.appendChild(document.createElement("div"));

  // append to the DOM (needed to obtain scrollHeight)
  document.body.appendChild(flex);
  var isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
  flex.parentNode.removeChild(flex);

  return isSupported;
}

if (checkFlexGap()) {
  body.classList.add("flexbox-gap");
} else {
  body.classList.add("no-flexbox-gap");
}

// Adding helper text to tables

const responsiveTables = document.querySelectorAll('.responsive-table');

responsiveTables.forEach(function(table){
  const containerWidth = table.offsetWidth;
  const tableWidth = table.querySelector('table > tbody').offsetWidth;


  const helperContainer = document.createElement('p');
  const helperContainerText = document.createTextNode('Scroll/swipe right more info');
  helperContainer.setAttribute('class', 'responsive-table__helper');
  helperContainer.appendChild(helperContainerText);
  
  if(tableWidth > containerWidth) {
    table.classList.add('is-overflowing');
    table.insertBefore(helperContainer, table.firstChild);
  }
});

// Add lazyload to iFrames

const allIframes = document.querySelectorAll('.video-embed > iframe');

allIframes.forEach(function(iFrame){
  iFrame.loading = 'lazy';
});



// Cookies banner

// var dropCookie = true;                  // False disables Cookie for testing
// var cookieDuration = 7;                // Number of days before cookie expires
// var cookieName = 'ssAcceptedCookies';
// var cookieValue = 'on';
 
// function createDiv(){
//     var bodytag = document.getElementsByTagName('body')[0];
//     var div = document.createElement('div');
//     div.setAttribute('class','cookies-banner');
//     // Change href below if your cookie policy page link is not /cookies/
//     div.innerHTML = '<div class="std-content"><p><strong>We use cookies to give you the best experience on our website. By continuing, you agree to our <a href="/privacy-policy/" rel="nofollow">privacy policy</a>.</strong></p></div><a class="btn btn--black" href="javascript:void(0);" onclick="removeMe();">I agree</a>';    
//     bodytag.insertBefore(div,bodytag.firstChild); // Add the banner just after the opening <body> tag
//     createCookie(window.cookieName,window.cookieValue, window.cookieDuration); // Create the cookie
// }  
// function createCookie(name,value,days) {
//     if (days) {
//         var date = new Date();
//         date.setTime(date.getTime()+(days*24*60*60*1000)); 
//         var expires = "; expires="+date.toGMTString(); 
//     }
//     else var expires = "";
//     if(window.dropCookie) { 
//         document.cookie = name+"="+value+expires+"; path=/"; 
//     }
// } 
// function checkCookie(name) {
//     var nameEQ = name + "=";
//     var ca = document.cookie.split(';');
//     for(var i=0;i < ca.length;i++) {
//         var c = ca[i];
//         while (c.charAt(0)==' ') c = c.substring(1,c.length);
//         if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
//     }
//     return null;
// } 
// function eraseCookie(name) {
//     createCookie(name,"",-1);
// } 
// window.onload = function(){
//     if(checkCookie(window.cookieName) != window.cookieValue){
//         createDiv(); 
//     }
// }
// function removeMe(){
//     var element = document.querySelector('.cookies-banner');
//     element.parentNode.removeChild(element);
// }


